<template>
  <div class="page-content--body with-submenu">
    <div class="page-content--body-left">
      <v-card
        max-width="320"
        outlined
        :class="`page-content--body-nav ${submenuBtn ? 'open' : ''}`"
      >
        <v-list v-model="selectedItem">
          <v-list-group
            v-for="(item, key) in group"
            :key="key+11"
            v-model="item.active"
            no-action
            :class="`${ item.arrow ? '' : 'no-arrow'}`"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title v-text="item.title"></v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item
              v-for="(child, key2) in item.itemsGroup"
              :key="key2+22"
              link
            >
              <v-list-item-content>
                <v-list-item-title v-text="child.title"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </v-list>
      </v-card>
    </div>

    <div class="page-content--body-right information">
      <v-card outlined class="information-table">
        <div class="information-table--head">
          <div class="information-table--head-search">
            <v-text-field
              required
              dense
              placeholder="Поиск"
              prepend-inner-icon="mdi-magnify"
              hide-details
            ></v-text-field>
          </div>
        </div>

        
        <div class="information-table--body">
          <div class="information-table--body-title td1">Название</div>
          <div class="information-table--body-title td2">Дата</div>
          <div class="information-table--body-title td3">&nbsp;</div>
        </div>

        <div class="information-table--content">
          <div class="information-table--content-point">
            <div class="point-trainer td1">
              <div class="point-trainer--img">
                <img alt="" src="@/assets/images/ico-xlsx.svg" />
              </div>
              <div class="table-about">
                <div class="table-title">Название документа</div>
                <div class="table-text">Краткое описание</div>
              </div>
            </div>
            <div class="point-date td2">
              <div class="table-title">21.06.2022</div>
            </div>
            <div class="point-button td3">
              <v-btn class="btn-blue btn-small" color="primary">Загрузить</v-btn>
            </div>
          </div>
          <div class="information-table--content-point">
            <div class="point-trainer td1">
              <div class="point-trainer--img">
                <img alt="" src="@/assets/images/ico-xlsx.svg" />
              </div>
              <div class="table-about">
                <div class="table-title">Название документа</div>
                <div class="table-text">Краткое описание</div>
              </div>
            </div>
            <div class="point-date td2">
              <div class="table-title">21.06.2022</div>
            </div>
            <div class="point-button td3">
              <v-btn class="btn-blue btn-small" color="primary">Загрузить</v-btn>
            </div>
          </div>
          <div class="information-table--content-point">
            <div class="point-trainer td1">
              <div class="point-trainer--img">
                <img alt="" src="@/assets/images/ico-docx.svg" />
              </div>
              <div class="table-about">
                <div class="table-title">Название документа</div>
                <div class="table-text">Краткое описание</div>
              </div>
            </div>
            <div class="point-date td2">
              <div class="table-title">21.06.2022</div>
            </div>
            <div class="point-button td3">
              <v-btn class="btn-blue btn-small" color="primary">Загрузить</v-btn>
            </div>
          </div>
          <div class="information-table--content-point">
            <div class="point-trainer td1">
              <div class="point-trainer--img">
                <img alt="" src="@/assets/images/ico-docx.svg" />
              </div>
              <div class="table-about">
                <div class="table-title">Название документа</div>
                <div class="table-text">Краткое описание</div>
              </div>
            </div>
            <div class="point-date td2">
              <div class="table-title">21.06.2022</div>
            </div>
            <div class="point-button td3">
              <v-btn class="btn-blue btn-small" color="primary">Загрузить</v-btn>
            </div>
          </div>
          <div class="information-table--content-point">
            <div class="point-trainer td1">
              <div class="point-trainer--img">
                <img alt="" src="@/assets/images/ico-pdf.svg" />
              </div>
              <div class="table-about">
                <div class="table-title">Название документа</div>
                <div class="table-text">Краткое описание</div>
              </div>
            </div>
            <div class="point-date td2">
              <div class="table-title">21.06.2022</div>
            </div>
            <div class="point-button td3">
              <v-btn class="btn-blue btn-small" color="primary">Загрузить</v-btn>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </div>

</template>

<script>
export default {
  name: 'Page6',
  data() {
    return {
      submenuBtn: true,
      selectedItem: 1,
      group: [
        {
          active: true,
          arrow: true,
          title: 'Техническая документация',
          itemsGroup: [
            { title: 'Сертификаты' },
            { title: 'Гарантиные талоны' },
            { title: 'Альбомы технических решений' },
            { title: 'Рекомендации' },
            { title: 'ГОСТы' },
          ],
        },
        {
          title: 'Каталоги',
          arrow: false,
        },
        {
          title: 'Проектирование',
          arrow: false,
        },
        {
          title: 'О ТеремПРО',
          arrow: false,
        },
      ],
      solo: [

      ],
    };
  },
};
</script>

<style lang="scss" scoped src="./page6.scss"/>
